import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function LoginPage() {
  const { login, startGoogleAuth } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/perfil";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success(`¡Hola ${r.user.name?.split(" ")[0] || ""}!`);
      if (r.user.role === "admin" || r.user.role === "operator") nav("/admin");
      else nav(next);
    } else {
      toast.error(r.error || "No se pudo iniciar sesión");
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="login-page">
      <div className="text-xs font-mono uppercase text-neutral-500">/entrar</div>
      <h1 className="font-display text-4xl tracking-tighter mt-1">Bienvenido</h1>
      <p className="text-sm text-neutral-500 mt-2">Entra para gestionar tus pedidos.</p>

      <form onSubmit={submit} className="mt-8 space-y-4">
        <div>
          <Label htmlFor="email" className="text-xs font-mono uppercase">Correo</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                 className="rounded-none mt-2 h-11" data-testid="login-email" />
        </div>
        <div>
          <Label htmlFor="password" className="text-xs font-mono uppercase">Contraseña</Label>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                 className="rounded-none mt-2 h-11" data-testid="login-password" />
        </div>
        <Button type="submit" disabled={loading} className="w-full h-12 brutal-btn bg-black hover:bg-[#FF3B30] text-white" data-testid="login-submit">
          {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
          Entrar
        </Button>
      </form>

      <div className="my-6 flex items-center gap-3">
        <div className="h-px bg-neutral-200 flex-1" />
        <span className="text-xs font-mono uppercase text-neutral-500">o</span>
        <div className="h-px bg-neutral-200 flex-1" />
      </div>

      <Button onClick={startGoogleAuth} variant="outline" className="w-full h-12 rounded-none border-black" data-testid="login-google">
        <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
        </svg>
        Continuar con Google
      </Button>

      <p className="text-sm text-center mt-6">
        ¿No tienes cuenta? <Link to="/registro" className="font-medium underline">Crear cuenta</Link>
      </p>
    </div>
  );
}
